<template>
  <div class="detail-receipt">
    <detail-receipt-plan class="table-wrap" :contract="contract" />
    <detail-receipt-record class="table-wrap" :contract="contract" />
  </div>
</template>
<script>
import DetailReceiptRecord from "./detail-receipt-record";
import DetailReceiptPlan from "./detail-receipt-plan";
export default {
  name: "detail-receipt",
  props: { contract: Object },
  data() {
    return {};
  },
  methods: {},
  components: { DetailReceiptRecord, DetailReceiptPlan },
};
</script>
<style scoped lang="scss">
.detail-receipt {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.table-wrap {
  flex: 1;
  padding-bottom: 15px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  ::v-deep {
    .new-btn-wrap {
      flex-shrink: 0;
      text-align: right;
      padding-bottom: 15px;
    }
    .btn-wrap {
      text-align: right;
    }
    .el-table {
      flex: 1;
      border: 1px solid #ebeef5;
      border-bottom: none;
    }
    .page {
      border: 1px solid #ebeef5;
      border-top: none;
    }
  }
  &:last-child {
    padding-bottom: 0;
  }
}
</style>
